import { useTheme } from 'styled-components';
import { SvgIconDefaultProps, CustomSvg } from '@libs/components';

const SortIcon: React.FC<SvgIconDefaultProps> = ({ className, color }) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.borders.default;

  return (
    <CustomSvg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.39518 0.833415L0.604821 0.833414C0.484701 0.833997 0.367426 0.875798 0.267828 0.953531C0.16823 1.03126 0.0907802 1.14144 0.0452733 1.27012C-0.000234187 1.39881 -0.0117555 1.54022 0.0121659 1.67649C0.0360869 1.81275 0.094376 1.93774 0.179664 2.03566L3.56877 5.95878C3.62523 6.02468 3.69241 6.07698 3.76642 6.11268C3.84043 6.14837 3.91982 6.16675 4 6.16675C4.08018 6.16675 4.15957 6.14837 4.23358 6.11268C4.30759 6.07698 4.37477 6.02468 4.43123 5.95878L7.82034 2.03566C7.90562 1.93774 7.96391 1.81275 7.98783 1.67649C8.01176 1.54022 8.00023 1.39881 7.95473 1.27012C7.90922 1.14144 7.83177 1.03126 7.73217 0.953531C7.63257 0.875798 7.5153 0.833998 7.39518 0.833415Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default SortIcon;
